import { Controller } from "stimulus"

export default class extends Controller {
  reset() {
    this.element.reset()
    this.element.querySelectorAll('.is-invalid').forEach((element) => element.classList.remove('is-invalid'))
    this.element.querySelectorAll('.form-error').forEach((element) => element.remove())
  }
}
